export const articlePreviews = [
  {
    id: 1,
    title: 'Sugargoo Spreadsheet Complete Guide 2026',
    excerpt: 'Everything from beginner basics to advanced product research. Learn how to find the best deals, verify sellers, and master Sugargoo shopping.',
    link: '/article/sugargoo-spreadsheet-complete-guide',
    badge: 'Ultimate Guide',
    readTime: '12 min',
  },
  {
    id: 2,
    title: 'Sugargoo Review 2026: Is It Worth Your Time?',
    excerpt: 'In-depth independent review covering platform features, pros, cons, user experience, and honest assessment of the Sugargoo shopping agent.',
    link: '/article/sugargoo-review',
    badge: 'Review',
    readTime: '10 min',
  },
  {
    id: 3,
    title: 'Sugargoo Shipping Cost Guide: Save Money on International Delivery',
    excerpt: 'Compare all shipping methods, understand weight-based pricing, learn rehearsal shipping tricks, and find the cheapest reliable delivery options.',
    link: '/article/sugargoo-shipping-cost-guide',
    badge: 'Shipping',
    readTime: '8 min',
  },
  {
    id: 4,
    title: 'Sugargoo Coupon Codes & Discount Guide 2026',
    excerpt: 'Stay updated with the latest Sugargoo coupon codes, seasonal promotions, loyalty rewards, and proven strategies to maximize your savings.',
    link: '/article/sugargoo-coupon-guide',
    badge: 'Savings',
    readTime: '7 min',
  },
  {
    id: 5,
    title: 'How to Find the Best Sugargoo Spreadsheet for Your Style',
    excerpt: 'Not all spreadsheets are equal. Learn how to evaluate quality, spot active curators, and find collections that match your personal fashion taste.',
    link: '/article/sugargoo-spreadsheet-complete-guide',
    badge: 'Tips',
    readTime: '6 min',
  },
  {
    id: 6,
    title: 'Sugargoo Warehouse Guide: How Storage & Consolidation Work',
    excerpt: 'Understand how the Sugargoo warehouse system operates, storage time limits, package consolidation, and how to manage multiple orders efficiently.',
    link: '/article/sugargoo-shipping-cost-guide',
    badge: 'Warehouse',
    readTime: '9 min',
  },
  {
    id: 7,
    title: 'Sugargoo vs Other Shopping Agents: Honest Comparison',
    excerpt: 'Side-by-side comparison of Sugargoo against other popular agents — fees, shipping speed, service quality, and which one suits your needs.',
    link: '/article/sugargoo-review',
    badge: 'Comparison',
    readTime: '11 min',
  },
  {
    id: 8,
    title: 'Sugargoo Beginner Tutorial: First Order Step by Step',
    excerpt: 'A complete walkthrough for first-time users — from account creation to receiving your first package, with screenshots and practical tips.',
    link: '/article/sugargoo-spreadsheet-complete-guide',
    badge: 'Tutorial',
    readTime: '8 min',
  },
  {
    id: 9,
    title: 'Top Sugargoo Finds: Trending Products This Month',
    excerpt: 'Curated collection of the hottest products discovered through Sugargoo Spreadsheet — streetwear, sneakers, accessories, and hidden gems.',
    link: '/article/sugargoo-coupon-guide',
    badge: 'Trending',
    readTime: '5 min',
  },
];